import { FleekError } from './FleekError';

type StorageUploadFileCountQuotaExceededErrorOptions = {
  quota?: number;
};

export class StorageUploadFileCountQuotaExceededError extends FleekError<StorageUploadFileCountQuotaExceededErrorOptions> {
  public name = 'StorageUploadFileCountQuotaExceededError';

  constructor(data: StorageUploadFileCountQuotaExceededErrorOptions = {}) {
    super(data);
  }

  toString = () => {
    if (this.data?.quota) {
      return `Sorry, you have reached your daily limit of ${this.data.quota} file uploads. We are unable to process your request.`;
    }

    return 'You have exceeded your file upload limit for the past 24 hours.';
  };
}
